import { Injectable } from '@angular/core';
import { LoginConstants } from '../constants/constants';
import { Subject } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private churchId: string = null;
  private churchIdChange = new Subject<string>();
  churchIdChange$ = this.churchIdChange.asObservable();

  constructor() {
    // Check for existing token and initialize churchId
    const token = localStorage.getItem(LoginConstants.ACCESS_TOKEN);
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        this.churchId = payload.church_id;
      } catch (error) {
        console.error('Error parsing token:', error);
      }
    }
    if(environment.isController){
      this.churchId = environment.churchId;
    }
  }

  getChurchId(): string {
    return this.churchId;
  }

  setTokens(accessToken: string, refreshToken: string) {
    localStorage.setItem(LoginConstants.ACCESS_TOKEN, accessToken);
    localStorage.setItem(LoginConstants.REFRESH_TOKEN, refreshToken);

    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      this.churchId = payload.church_id;
      this.churchIdChange.next(this.churchId);
    } catch (error) {
      console.error('Error parsing token:', error);
    }
  }

  clearTokens() {
    localStorage.clear();
    this.churchId = null;
    this.churchIdChange.next(null);
  }
}